module.exports = __webpack_public_path__ + "img/isu.7c954518.png";